import { FilterReplacementStatus } from 'common';
import { AlertCircle as LucideAlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { tokens } from 'tamagui-config';

export interface FilterAlertProps {
  title: string;
  icon: React.ReactNode;
  backgroundColor: string;
  textColor: string;
}

export const getAlertProps = (
  filterReplacementStatus: FilterReplacementStatus,
): FilterAlertProps => {
  const { t } = useTranslation();
  switch (filterReplacementStatus) {
    case FilterReplacementStatus.FilterChangeUpcoming:
      return {
        title: t('hvac.filterChangeUpcoming'),
        icon: <LucideAlertCircle size={80} color={tokens.color.warning} />,
        backgroundColor: tokens.color.warning,
        textColor: tokens.color.warning,
      };
    case FilterReplacementStatus.FilterChangeOverdue:
      return {
        title: t('hvac.filterChangeOverdue'),
        icon: <LucideAlertCircle size={80} color={tokens.color.energyRed} />,
        backgroundColor: tokens.color.energyRed,
        textColor: tokens.color.energyRed,
      };
    case FilterReplacementStatus.HVACFilterAlert:
      return {
        title: t('hvac.filterNeedsReplacement'),
        icon: <LucideAlertCircle size={80} color={tokens.color.energyRed} />,
        backgroundColor: tokens.color.energyRed,
        textColor: tokens.color.energyRed,
      };
    case FilterReplacementStatus.HVACFilterAlertCritical:
      return {
        title: 'Filter needs replacement', // Critical priority - red background
        icon: <LucideAlertCircle size={80} color={tokens.color.energyRed} />,
        backgroundColor: tokens.color.energyRed,
        textColor: tokens.color.energyRed,
      };
    case FilterReplacementStatus.HVACFilterAlertModerate:
      return {
        title: 'Filter appears to need replacement', // Moderate priority - orange/yellow background
        icon: <LucideAlertCircle size={80} color={tokens.color.warning} />,
        backgroundColor: tokens.color.warning,
        textColor: tokens.color.warning,
      };
    case FilterReplacementStatus.ServiceRequested:
      return {
        title: t('hvac.serviceRequested'),
        icon: <LucideAlertCircle size={80} color={tokens.color.deltaBlue} />,
        backgroundColor: tokens.color.deltaBlue,
        textColor: tokens.color.deltaBlue,
      };
    case FilterReplacementStatus.FilterOrdered:
      return {
        title: t('hvac.filterOrdered'),
        icon: <LucideAlertCircle size={80} color={tokens.color.deltaBlue} />,
        backgroundColor: tokens.color.deltaBlue,
        textColor: tokens.color.deltaBlue,
      };
    case FilterReplacementStatus.NoFilterChangeNeeded:
      return {
        title: t('hvac.noFilterChangeNeeded'),
        icon: <LucideAlertCircle size={80} color={tokens.color.successGreen} />,
        backgroundColor: tokens.color.successGreen,
        textColor: tokens.color.textLight,
      };
  }
};
